import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from './avatar';
import { cn } from '../../lib/utils';

// Logo cuadrado con fallback de iniciales. Reutilizable para liga / torneo / club.
const initials = (name = '') =>
  name.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase() || '?';

export default function EntityLogo({ src, name, className }) {
  return (
    <Avatar className={cn('rounded-md', className)}>
      {src ? <AvatarImage src={src} alt={name || ''} className="object-contain" /> : null}
      <AvatarFallback className="rounded-md bg-muted text-xs font-semibold text-muted-foreground">
        {initials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
